import MaskedInput from '@/components/form/masked-input';
import {DocumentInputField} from '@/engine';
import {useDocumentLocale} from '../../hooks/use-document-locale';
import {FieldProps} from '../../meta-field';

export const MaskedInputField = ({
  field,
  value,
  handleChange,
  handleBlur,
  handleFocus,
}: FieldProps<DocumentInputField>) => {
  const {_t, locale} = useDocumentLocale();
  const updatedValue = value === '' ? undefined : value;

  return (
    <MaskedInput
      data-testid={`${field.id}_input`}
      isUppercasedMask={field.uppercasedMask}
      locale={locale}
      mask={field.mask}
      maxLength={field.maxLength}
      name={field.id}
      onAccept={value => handleChange(value)}
      onBlur={handleBlur}
      onFocus={handleFocus}
      placeholder={_t(field.placeholder)}
      readOnly={field.readonly}
      required={field.required}
      type={field.type}
      value={updatedValue}
    />
  );
};
